(function init() {
  function showMenu(menu) {
    menu.element
      .closest('li')
      .querySelector('[data-mega-nav-menu-panel]')
      .classList.add('is-active');
    const keydown = menu.element.querySelector('[data-mega-nav-menu-item-keydown]');
    keydown.setAttribute('aria-expanded', 'true');
    keydown.ariaLabel = keydown.ariaLabel.replace('Open', 'Close');
    keydown.style.transform = 'rotate(180deg)';
  }

  function hideMenu(menu) {
    menu.element
      .closest('li')
      .querySelector('[data-mega-nav-menu-panel]')
      .classList.remove('is-active');
    const keydown = menu.element.querySelector('[data-mega-nav-menu-item-keydown]');
    keydown.setAttribute('aria-expanded', 'false');
    keydown.ariaLabel = keydown.ariaLabel.replace('Close', 'Open');
    keydown.style.transform = 'rotate(0deg)';
  }

  function closeMenu(menu) {
    hideMenu(menu);
    menu.trap.deactivate();
    menu.active = false;
  }

  function initMenu(element) {
    const m = { element, active: false };

    const trap = window.focusTrap.createFocusTrap(element, {
      clickOutsideDeactivates: true,
      escapeDeactivates: true,
      initialFocus: () => element.querySelector('.mega-nav-menu-panel__list'),
      onDeactivate: () => {
        closeMenu({ ...m, trap });
      },
    });

    return { element, active: false, trap };
  }

  const menusEls = document.querySelectorAll('[data-mega-nav-menu-item]');
  const menus = [...menusEls].map((el) => initMenu(el));

  function openMenu(menu) {
    showMenu(menu);
    menu.trap.activate();
    menu.active = true;
  }

  function toggleMenuOpen(e, menu) {
    e.preventDefault();
    if (!menu.active) {
      // close other menus
      menus.forEach((m) => {
        if (m.element !== menu.element) {
          closeMenu(m);
        }
      });

      openMenu(menu);
    } else {
      closeMenu(menu);
    }
  }

  // attach listeners
  menus.forEach((m) => {
    const hover = m.element.querySelector('[data-mega-nav-menu-item-hover]');
    const panel = m.element.querySelector('[data-mega-nav-menu-panel]');
    const keydown = m.element.querySelector('[data-mega-nav-menu-item-keydown]');

    if (keydown) {
      keydown.addEventListener('keydown', (e) =>
        e.code === 'Space' || e.code === 'Enter' ? toggleMenuOpen(e, m) : null,
      );
      keydown.addEventListener('click', (e) => toggleMenuOpen(e, m));
    }

    let timeout = 0;

    if (hover) {
      hover.addEventListener('mouseenter', (e) => {
        menus.forEach((m) => (m.active ? closeMenu(m) : null));
        clearTimeout(timeout);
        openMenu(m);
      });

      panel.addEventListener('mouseleave', (e) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          closeMenu(m);
        }, 500);
      });
    }
  });
})();
